import { request } from "services/api/util";

class SurveyService {
  async getListSurvey(params) {
    const config = {
      method: "get",
      url: `admin/survey`,
      params: params,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getDetailSurvey(id) {
    const config = {
      method: "get",
      url: `admin/survey/${id}`,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async createSurvey(body) {
    const config = {
      method: "post",
      url: `admin/survey`,
      data: body,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async updateSurvey(body, id) {
    const config = {
      method: "put",
      url: `admin/survey/${id}`,
      data: body,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async uploadSurveyResult(body, id) {
    const config = {
      method: "post",
      url: `admin/survey/result/${id}`,
      data: body,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getSurveyResult(param, id) {
    const config = {
      method: "get",
      url: `admin/survey/result/${id}`,
      params: param,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async deleteSurveyResult(id) {
    const config = {
      method: "delete",
      url: `admin/survey/result/${id}`,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async uploadExcelSurveyResult(body, id) {
    const config = {
      method: "post",
      url: `admin/survey/${id}/surveyUrls`,
      data: body,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
}

export default new SurveyService();
